// src/services/socketApp.js
import feathers from '@feathersjs/feathers';
import socketio from '@feathersjs/socketio-client';
import auth from '@feathersjs/authentication-client';
import io from 'socket.io-client';

// Debe apuntar al server "mode sockets"
const socketURL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3031';

// ⚠️ App Engine: NO uses solo websocket. Deja polling + websocket
export const socket = io(socketURL, {
  path: process.env.REACT_APP_SOCKET_PATH || '/socket.io',
  transports: ['polling', 'websocket'], // ✅ importantísimo
  upgrade: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  timeout: 20000,
  autoConnect: false,
});

// Logs de debug
socket.on('connect', () => console.log('[socket] connected', socket.id));
socket.on('disconnect', (r) => console.log('[socket] disconnected', r));
socket.on('connect_error', (e) => console.log('[socket] connect_error', e?.message || e));
socket.on('error', (e) => console.log('[socket] error', e));

// Feathers client para socket
const socketApp = feathers()
  .configure(socketio(socket, { timeout: 20000 }))
  .configure(auth({ storage: window.localStorage }));

export default socketApp;
